import { useI18n } from '@/lib/i18n'
import './LanguageSwitcher.css'

// Real links to the other language's URL (crawlable, open-in-new-tab
// works); a plain click switches in place behind the curtain.
export default function LanguageSwitcher() {
  const { lang, setLang, hrefFor, t } = useI18n()
  return (
    <div className="lang-toggle" role="group" aria-label={t('nav.language')}>
      {(['DE', 'EN'] as const).map((l) => (
        <a
          key={l}
          href={hrefFor(l)}
          className="lang-toggle__opt"
          aria-current={lang === l ? 'true' : undefined}
          lang={l.toLowerCase()}
          hrefLang={l.toLowerCase()}
          onClick={(e) => {
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return
            e.preventDefault()
            setLang(l)
          }}
        >
          {l}
        </a>
      ))}
    </div>
  )
}
